import { Check } from '../../../types/check';

export const emptyCheck: Check = {
  drawerId: '',
};
